export default __webpack_public_path__ + "static/media/head03_vi_pc.1a5d868b.png";